import { useState, useMemo, useEffect } from "react";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import { changepassword, updateMerchants } from "../../components/actions/auth";
import { Link } from "react-router-dom";
import { uploadImage } from "../../components/actions/campaign";

export default function SettingsPage() {
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");
  const [bannerFiles, setBannerFiles] = useState([]);
  const [bannerPreviews, setBannerPreviews] = useState([]);

  const [activeTab, setActiveTab] = useState("profile");

  const code = localStorage.getItem("code");

  const portalUrl =
  code === "MER14505202"
    ? "https://simiradiagnostics.primexloyalty.com/"
    : "https://simiradiagnostics.primexloyalty.com/";

  const [showPassword, setShowPassword] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New loading state
  const [passwordForm, setPasswordForm] = useState({
    email: sessionStorage.getItem("email") || "",
    newPassword: "",
    confirmPassword: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [isSavingProfile, setIsSavingProfile] = useState(false);

  const [merchantData, setMerchantData] = useState({
    id: "",
    code: "",
    country: "",
    timeZone: "",
    city: "",
    industry: "",
    isRedemption: false,
    merchantClientId: "",
    merchantClientSecret: "",
    email: "",
    mobile: "",
    company: "",
    portalName: "",
    portalTitle: "",
    welcomeMessage: "",
    description: "",
    purpose: "",
    remarks: "",
    status: true,
    logolink: "",
    bannerlink: "",
  });
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    if (userData) {
      setMerchantData({
        id: userData.name || "",
        code: userData.code || "",
        country: userData.country || "",
        timeZone: userData.timeZone || "",
        city: userData.city || "",
        industry: userData.industry || "",
        isRedemption: userData.isRedemption || false,
        merchantClientId: userData.merchantClientId || "",
        merchantClientSecret: userData.merchantClientSecret || "",
        email: userData.email || "",
        mobile: userData.mobile || "",
        company: userData.company || "",
        portalName: userData.portalName || "",
        portalTitle: userData.portalTitle || "",
        welcomeMessage: userData.welcomeMessage || "",
        description: userData.description || "",
        purpose: userData.purpose || "",
        remarks: userData.remarks || "",
        status: userData.status ?? true,
        logolink: userData.logolink || "",
        bannerlink: userData.bannerlink || "",
      });
    }
  }, []); // सिर्फ़ एक बार पेज लोड पर चलेगा
  const [notificationSettings, setNotificationSettings] = useState({
    campaign: true,
    customer: true,
    transaction: true,
    system: true,
  });

  const [portalFeatures, setPortalFeatures] = useState({
    points: true,
    rewards: true,
    transactions: true,
    profile: true,
    notifications: true,
    referrals: true,
  });

  useEffect(() => {
    const handleSetActiveTab = (event) => {
      const tab = event.detail;
      if (
        ["profile", "security", "notifications", "portal", "help"].includes(tab)
      ) {
        setActiveTab(tab);
      }
    };

    window.addEventListener("setActiveTab", handleSetActiveTab);
    return () => window.removeEventListener("setActiveTab", handleSetActiveTab);
  }, []);

  const handleInputChange = (field, value) => {
    setMerchantData((prev) => ({ ...prev, [field]: value }));
  };
  const handleLogoChange = (e) => {
    if (e.target.files[0]) {
      setLogoFile(e.target.files[0]);
    }
  };

  const handleBannerChange = (e) => {
    setBannerFiles(Array.from(e.target.files));
  };
  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please select a valid image file");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert("Image size should be less than 5MB");
      return;
    }

    const reader = new FileReader();
    reader.onload = (ev) => {
      setLogoPreview(ev.target.result);
    };
    reader.readAsDataURL(file);

    setLogoFile(file);
  };

  // Banner Upload (multiple)
  const handleBannerUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const validFiles = [];
    const newPreviews = [];

    files.forEach((file) => {
      if (!file.type.startsWith("image/")) {
        alert(`Invalid file: ${file.name}`);
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert(`Too large: ${file.name}`);
        return;
      }

      validFiles.push(file);
      const reader = new FileReader();
      reader.onload = (ev) => {
        newPreviews.push(ev.target.result);
        if (newPreviews.length === validFiles.length) {
          setBannerPreviews((prev) => [...prev, ...newPreviews]);
        }
      };
      reader.readAsDataURL(file);
    });

    setBannerFiles((prev) => [...prev, ...validFiles]);
  };

  const removeLogo = () => {
    setLogoFile(null);
    setLogoPreview("");
    setMerchantData((prev) => ({ ...prev, logolink: "" })); // save पर blank जाएगा
  };

  const removeBanner = (index) => {
    // index = displayed image का position (0,1,2...)
    const totalExisting = merchantData.bannerlink
      ? merchantData.bannerlink.split(",").filter(Boolean).length
      : 0;

    if (index < totalExisting) {
      // पुराना banner delete कर रहे हैं → merchantData से URL हटाओ
      const urls = merchantData.bannerlink.split(",").filter(Boolean);
      urls.splice(index, 1);
      setMerchantData((prev) => ({ ...prev, bannerlink: urls.join(",") }));
    } else {
      // नया banner (preview) delete कर रहे हैं
      const newIndex = index - totalExisting;
      setBannerFiles((prev) => prev.filter((_, i) => i !== newIndex));
      setBannerPreviews((prev) => prev.filter((_, i) => i !== newIndex));
    }
  };
  const handleSaveProfile = async () => {
    if (!merchantData.email.includes("@")) {
      alert("Please enter a valid email address");
      return;
    }
    if (!/^\d{10}$/.test(merchantData.mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    setIsSavingProfile(true);

    try {
      let finalLogoLink = merchantData.logolink;
      let finalBannerLinks = merchantData.bannerlink || "";

      // Upload Logo - direct file object (जैसे दूसरे page पर)
      if (logoFile) {
        const response = await uploadImage(
          merchantData.code || "default",
          logoFile
        );
        if (response && response.url) {
          finalLogoLink = response.url;
        } else {
          alert("Logo upload failed");
          setIsSavingProfile(false);
          return;
        }
      }

      // Upload Banners
      if (bannerFiles.length > 0) {
        const existingUrls = finalBannerLinks
          ? finalBannerLinks.split(",").filter(Boolean)
          : [];
        const newUrls = [];

        for (const file of bannerFiles) {
          const response = await uploadImage(
            merchantData.code || "default",
            file
          );
          if (response && response.url) {
            newUrls.push(response.url);
          } else {
            alert(`Banner upload failed: ${file.name}`);
          }
        }

        finalBannerLinks = [...existingUrls, ...newUrls].join(",");
      }

      // अगर logo delete किया और कोई नया नहीं डाला → blank
      if (!logoFile && logoPreview === "" && merchantData.logolink) {
        finalLogoLink = "";
      }

      const payload = {
        code: merchantData.code || "",
        name: merchantData.id || "",
        mobile: merchantData.mobile || "",
        company: merchantData.company || "",
        industry: merchantData.industry || "",
        purpose: merchantData.purpose || "",
        description: merchantData.description || "",
        status: merchantData.status ? 1 : 0,
        isRedemption: merchantData.isRedemption ? 1 : 0,
        portalName: merchantData.portalName || "",
        country: merchantData.country || "",
        timeZone: merchantData.timeZone || "",
        city: merchantData.city || "",
        logolink: finalLogoLink,
        bannerlink: finalBannerLinks,
      };

      const res = await updateMerchants(payload);

      if (res?.message === "success") {
        const updatedUserData = {
          ...JSON.parse(sessionStorage.getItem("userData") || "{}"),
          logolink: finalLogoLink,
          bannerlink: finalBannerLinks,
          name: merchantData.id,
          company: merchantData.company,
          // ... बाकी fields अगर जरूरी हों
        };
        sessionStorage.setItem("userData", JSON.stringify(updatedUserData));
        setMerchantData((prev) => ({
          ...prev,
          logolink: finalLogoLink,
          bannerlink: finalBannerLinks,
        }));
        // Reset
        setLogoFile(null);
        setLogoPreview("");
        setBannerFiles([]);
        setBannerPreviews([]);

        setIsEditing(false);
        setShowSuccessModal(true);
      } else {
        alert(res?.message || "Failed to update profile");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while saving");
    } finally {
      setIsSavingProfile(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      alert("New password and confirm password do not match");
      return;
    }
    if (
      !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,16}$/.test(
        passwordForm.newPassword
      )
    ) {
      alert(
        "Password must be 6-16 characters, including uppercase, lowercase, number, and special character"
      );
      return;
    }

    setIsLoading(true);
    try {
      const res = await changepassword(
        passwordForm.email,
        passwordForm.newPassword
      );
      setIsLoading(false);
      if (res?.message === "success") {
        setMerchantData((prev) => ({
          ...prev,
          password: passwordForm.newPassword,
        }));
        setShowChangePasswordModal(false);
        setShowSuccessModal(true);
        setPasswordForm({
          email: passwordForm.email,
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        alert(res?.message || "Failed to update password");
      }
    } catch (error) {
      setIsLoading(false); // Stop loader on error
      alert("An error occurred while updating the password");
    }
  };

  const handleNotificationToggle = (id) => {
    setNotificationSettings((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePortalFeatureToggle = (id) => {
    setPortalFeatures((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const supportTopics = [
    {
      title: "Getting Started",
      description: "Learn how to set up your loyalty program",
      icon: "ri-rocket-line",
      color: "bg-blue-100 text-blue-600",
    },
    {
      title: "Campaign Management",
      description: "Create and manage effective campaigns",
      icon: "ri-megaphone-line",
      color: "bg-green-100 text-green-600",
    },
    {
      title: "Customer Management",
      description: "Track and engage with your customers",
      icon: "ri-user-line",
      color: "bg-purple-100 text-purple-600",
    },
    {
      title: "Transactions & Reports",
      description: "Understand your transaction data",
      icon: "ri-bar-chart-line",
      color: "bg-orange-100 text-orange-600",
    },
    {
      title: "API Integration",
      description: "Integrate with our powerful APIs",
      icon: "ri-code-line",
      color: "bg-red-100 text-red-600",
    },
    {
      title: "Billing & Pricing",
      description: "Manage your subscription and billing",
      icon: "ri-money-dollar-circle-line",
      color: "bg-yellow-100 text-yellow-600",
    },
  ];

  const faqs = [
    {
      question: "How do I create a new loyalty campaign?",
      answer:
        'Navigate to the Campaigns section and click "Create Campaign". Follow the step-by-step wizard to set up your campaign rules, rewards, and duration.',
    },
    {
      question: "How can I track customer engagement?",
      answer:
        "Use the Dashboard analytics to view customer engagement metrics, or go to the Customers section for detailed individual customer profiles.",
    },
    {
      question: "What payment methods are supported?",
      answer:
        "We support all major credit cards, debit cards, and digital payment methods. Enterprise customers can also use bank transfers.",
    },
    {
      question: "How secure is customer data?",
      answer:
        "We use enterprise-grade encryption and comply with international data protection standards including GDPR and CCPA.",
    },
    {
      question: "Can I export my data?",
      answer:
        "Yes, you can export customer data, transaction reports, and analytics from any section using the Export button.",
    },
  ];

  return (
    <DashboardLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
          <p className="text-gray-600 mt-1">
            Manage your account settings and preferences
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex overflow-x-auto">
              {[
                {
                  id: "profile",
                  label: "Profile Information",
                  icon: "ri-user-line",
                },
                { id: "security", label: "Security", icon: "ri-shield-line" },
                // { id: 'notifications', label: 'Notifications', icon: 'ri-notification-line' },
                {
                  id: "portal",
                  label: "Customer Portal",
                  icon: "ri-global-line",
                },
                {
                  id: "help",
                  label: "Help & Support",
                  icon: "ri-question-line",
                },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-6 py-4 font-semibold text-sm border-b-2 transition-colors whitespace-nowrap ${
                    activeTab === tab.id
                      ? "border-blue-500 text-blue-600 bg-blue-50"
                      : "border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                  aria-label={`Switch to ${tab.label} tab`}
                >
                  <i className={`${tab.icon} text-lg`}></i>
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="p-6">
            {activeTab === "profile" && (
              <div className="space-y-8">
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl font-bold text-gray-900">
                    Merchant Profile
                  </h2>
                  <div className="flex gap-3">
                    {isEditing ? (
                      <>
                        <button
                          onClick={() => {
                            setIsEditing(false);
                            setLogoFile(null);
                            setBannerFiles([]);
                            // Cancel पर original data वापस load करो
                            if (userData) {
                              setMerchantData({
                                id: userData.name || "",
                                code: userData.code || "",
                                country: userData.country || "",
                                timeZone: userData.timeZone || "",
                                city: userData.city || "",
                                industry: userData.industry || "",
                                isRedemption: userData.isRedemption || false,
                                merchantClientId:
                                  userData.merchantClientId || "",
                                merchantClientSecret:
                                  userData.merchantClientSecret || "",
                                email: userData.email || "",
                                mobile: userData.mobile || "",
                                company: userData.company || "",
                                portalName: userData.portalName || "",
                                portalTitle: userData.portalTitle || "",
                                welcomeMessage: userData.welcomeMessage || "",
                                description: userData.description || "",
                                purpose: userData.purpose || "",
                                remarks: userData.remarks || "",
                                status: userData.status || true,
                                logolink: userData.logolink || "",
                                bannerlink: userData.bannerlink || "",
                              });
                            }
                          }}
                          disabled={isSavingProfile}
                          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors disabled:opacity-50"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleSaveProfile}
                          disabled={isSavingProfile}
                          className="px-4 py-2 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors disabled:opacity-50 flex items-center gap-2"
                        >
                          {isSavingProfile ? (
                            <>
                              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                              Saving...
                            </>
                          ) : (
                            <>
                              <i className="ri-save-line"></i>
                              Save Changes
                            </>
                          )}
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={() => setIsEditing(true)}
                        className="px-4 py-2 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors"
                      >
                        <i className="ri-edit-line mr-2"></i>
                        Edit Profile
                      </button>
                    )}
                  </div>
                </div>

                {/* Basic Information */}
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Basic Information
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Merchant ID
                      </label>
                      <input
                        type="text"
                        value={merchantData.id}
                        disabled
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Merchant Code
                      </label>
                      <input
                        type="text"
                        value={merchantData.code}
                        disabled
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Name
                      </label>
                      <input
                        type="text"
                        value={merchantData.id}
                        onChange={(e) =>
                          handleInputChange("id", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Company
                      </label>
                      <input
                        type="text"
                        value={merchantData.company}
                        onChange={(e) =>
                          handleInputChange("company", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Industry
                      </label>
                      <select
                        value={merchantData.industry}
                        onChange={(e) =>
                          handleInputChange("industry", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none cursor-pointer"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      >
                        <option value="Automotive">Automotive</option>
                        <option value="Retail">Retail</option>
                        <option value="Healthcare">Healthcare</option>
                        <option value="Technology">Technology</option>
                        <option value="Food & Beverage">Food & Beverage</option>
                        <option value="Fashion">Fashion</option>
                        <option value="Travel">Travel</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Portal Name
                      </label>
                      <input
                        type="text"
                        value={merchantData.portalName}
                        onChange={(e) =>
                          handleInputChange("portalName", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                  </div>
                </div>

                {/* Contact Information */}
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Contact Information
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Email
                      </label>
                      <input
                        type="email"
                        value={merchantData.email}
                        onChange={(e) =>
                          handleInputChange("email", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Mobile
                      </label>
                      <input
                        type="tel"
                        value={merchantData.mobile}
                        onChange={(e) =>
                          handleInputChange("mobile", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Country
                      </label>
                      <input
                        type="text"
                        value={merchantData.country}
                        onChange={(e) =>
                          handleInputChange("country", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        City
                      </label>
                      <input
                        type="text"
                        value={merchantData.city}
                        onChange={(e) =>
                          handleInputChange("city", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Time Zone
                      </label>
                      <select
                        value={merchantData.timeZone}
                        onChange={(e) =>
                          handleInputChange("timeZone", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none cursor-pointer"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      >
                        <option value="Asia/Kolkata">
                          Asia/Kolkata (UTC+05:30)
                        </option>
                        <option value="America/New_York">
                          America/New_York (UTC-05:00)
                        </option>
                        <option value="Europe/London">
                          Europe/London (UTC+00:00)
                        </option>
                        <option value="Asia/Tokyo">
                          Asia/Tokyo (UTC+09:00)
                        </option>
                        <option value="Australia/Sydney">
                          Australia/Sydney (UTC+10:00)
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Business Details */}
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Business Details
                  </h3>
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Description
                      </label>
                      <textarea
                        value={merchantData.description}
                        onChange={(e) =>
                          handleInputChange("description", e.target.value)
                        }
                        disabled={!isEditing}
                        rows={3}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Business Purpose
                      </label>
                      <textarea
                        value={merchantData.purpose}
                        onChange={(e) =>
                          handleInputChange("purpose", e.target.value)
                        }
                        disabled={!isEditing}
                        rows={4}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Remarks
                      </label>
                      <input
                        type="text"
                        value={merchantData.remarks}
                        onChange={(e) =>
                          handleInputChange("remarks", e.target.value)
                        }
                        disabled={!isEditing}
                        className={`w-full px-4 py-3 border border-gray-300 rounded-lg ${
                          isEditing
                            ? "bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            : "bg-gray-100 text-gray-600"
                        }`}
                      />
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 rounded-xl p-6 mt-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Logo & Banners
                  </h3>

                  <div className="mb-8">
                    <label className="block text-sm font-medium text-gray-700 mb-3">
                      {" "}
                      Logo
                    </label>
                    <div className="relative inline-block group">
                      {logoPreview || merchantData.logolink ? (
                        <>
                          <img
                            src={logoPreview || merchantData.logolink}
                            alt="Logo"
                            className="w-48 h-48 object-contain border-2 border-gray-300 rounded-xl"
                          />
                          {isEditing && (
                            <>
                              <label className="absolute inset-0 bg-black bg-opacity-40 rounded-xl flex items-center justify-center opacity-0 group-hover:opacity-100 cursor-pointer">
                                <div className="text-center text-white">
                                  <i className="ri-upload-2-line text-3xl mb-2"></i>
                                  <p>Change Logo</p>
                                </div>
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleLogoUpload}
                                  className="hidden"
                                />
                              </label>
                              <button
                                onClick={removeLogo}
                                className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-2 opacity-0 group-hover:opacity-100"
                              >
                                <i className="ri-delete-bin-line"></i>
                              </button>
                            </>
                          )}
                        </>
                      ) : isEditing ? (
                        <label className="w-48 h-48 border-4 border-dashed border-gray-400 rounded-xl flex flex-col items-center justify-center cursor-pointer hover:border-blue-500">
                          <i className="ri-image-add-line text-5xl text-gray-400 mb-3"></i>
                          <p className="text-sm font-medium">Upload Logo</p>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleLogoUpload}
                            className="hidden"
                          />
                        </label>
                      ) : (
                        <div className="w-48 h-48 bg-gray-200 rounded-xl flex items-center justify-center">
                          <i className="ri-image-line text-4xl text-gray-400"></i>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Banners */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-3">
                      Banner Images
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                      {[
                        ...(merchantData.bannerlink
                          ? merchantData.bannerlink.split(",").filter(Boolean)
                          : []),
                        ...bannerPreviews,
                      ].map((src, index) => (
                        <div key={index} className="relative group">
                          <img
                            src={src}
                            alt={`Banner ${index + 1}`}
                            className="w-full h-48 object-cover rounded-xl border-2 border-gray-300"
                          />
                          {isEditing && (
                            <button
                              onClick={() => removeBanner(index)}
                              className="absolute top-3 right-3 bg-red-500 text-white rounded-full p-2 opacity-0 group-hover:opacity-100"
                            >
                              <i className="ri-delete-bin-line"></i>
                            </button>
                          )}
                        </div>
                      ))}

                      {isEditing && (
                        <label className="h-48 border-4 border-dashed border-gray-400 rounded-xl flex flex-col items-center justify-center cursor-pointer hover:border-blue-500">
                          <i className="ri-image-add-line text-5xl text-gray-400 mb-3"></i>
                          <p className="text-sm font-medium">Add Banner</p>
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handleBannerUpload}
                            className="hidden"
                          />
                        </label>
                      )}
                    </div>
                  </div>
                </div>
                {/* Account Status & Settings */}
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Account Status & Settings
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                      <div>
                        <h4 className="font-semibold text-gray-900">
                          Account Status
                        </h4>
                        <p className="text-sm text-gray-600">
                          Current account status
                        </p>
                      </div>
                      <span
                        className={`px-3 py-1 rounded-full text-sm font-semibold ${
                          merchantData.status
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                        }`}
                      >
                        {merchantData.status ? "Active" : "Inactive"}
                      </span>
                    </div>
                    <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                      <div>
                        <h4 className="font-semibold text-gray-900">
                          Redemption Feature
                        </h4>
                        <p className="text-sm text-gray-600">
                          Allow customers to redeem points
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={merchantData.isRedemption}
                          onChange={(e) =>
                            handleInputChange("isRedemption", e.target.checked)
                          }
                          disabled={!isEditing}
                          className="sr-only peer"
                        />
                        <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "security" && (
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    Security Settings
                  </h2>
                  <p className="text-gray-600 mt-2">
                    Manage your account security and API credentials
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Password Management
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Current Password
                      </label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={userData.password}
                          disabled
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600 pr-12"
                          aria-label="Current Password"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                        >
                          <i
                            className={
                              showPassword ? "ri-eye-off-line" : "ri-eye-line"
                            }
                          ></i>
                        </button>
                      </div>
                    </div>
                    <button
                      onClick={() => setShowChangePasswordModal(true)}
                      className="bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 transition-colors"
                      aria-label="Change password"
                    >
                      <i className="ri-key-line mr-2"></i>
                      Change Password
                    </button>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    API Credentials
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Client ID
                      </label>
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={userData?.merchantClientId}
                          disabled
                          className="flex-1 px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                          aria-label="Client ID"
                        />
                        <button
                          onClick={() =>
                            navigator.clipboard.writeText(
                              merchantData.merchantClientId
                            )
                          }
                          className="px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50"
                          aria-label="Copy Client ID"
                        >
                          <i className="ri-file-copy-line"></i>
                        </button>
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Client Secret
                      </label>
                      <div className="flex gap-2">
                        <div className="relative flex-1">
                          <input
                            type={showClientSecret ? "text" : "password"}
                            value={userData?.merchantClientSecret}
                            disabled
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600 pr-12"
                            aria-label="Client Secret"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              setShowClientSecret(!showClientSecret)
                            }
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            aria-label={
                              showClientSecret
                                ? "Hide client secret"
                                : "Show client secret"
                            }
                          >
                            <i
                              className={
                                showClientSecret
                                  ? "ri-eye-off-line"
                                  : "ri-eye-line"
                              }
                            ></i>
                          </button>
                        </div>
                        <button
                          onClick={() =>
                            navigator.clipboard.writeText(
                              merchantData.merchantClientSecret
                            )
                          }
                          className="px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50"
                          aria-label="Copy Client Secret"
                        >
                          <i className="ri-file-copy-line"></i>
                        </button>
                      </div>
                    </div>
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                      <div className="flex items-center gap-2">
                        <i className="ri-warning-line text-yellow-600"></i>
                        <p className="text-yellow-700 text-sm font-medium">
                          Security Notice
                        </p>
                      </div>
                      <p className="text-yellow-700 text-sm mt-1">
                        Keep your API credentials secure. Never share them in
                        public repositories or client-side code.
                      </p>
                    </div>
                  </div>
                </div>
                {/* 
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Two-Factor Authentication</h3>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                      <div>
                        <h4 className="font-semibold text-gray-900">SMS Authentication</h4>
                        <p className="text-sm text-gray-600">Last OTP: {merchantData.lastOtp}</p>
                      </div>
                      <button
                        className="bg-green-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-green-600 transition-colors"
                        aria-label="SMS Authentication Status"
                      >
                        <i className="ri-shield-check-line mr-2"></i>
                        Enabled
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
            )}
            {/* 
            {activeTab === 'notifications' && (
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">Notification Preferences</h2>
                  <p className="text-gray-600 mt-2">Choose how you want to receive notifications</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Email Notifications</h3>
                  <div className="space-y-4">
                    {[
                      { id: 'campaign', label: 'Campaign Updates', desc: 'Get notified about campaign performance' },
                      { id: 'customer', label: 'New Customer Signups', desc: 'Receive alerts when new customers join' },
                      { id: 'transaction', label: 'Transaction Alerts', desc: 'Daily summary of transactions' },
                      { id: 'system', label: 'System Updates', desc: 'Important system maintenance notifications' },
                    ].map((item) => (
                      <div key={item.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                        <div>
                          <h4 className="font-semibold text-gray-900">{item.label}</h4>
                          <p className="text-sm text-gray-600">{item.desc}</p>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={notificationSettings[item.id]}
                            onChange={() => handleNotificationToggle(item.id)}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                      </div>
                    ))}
                  </div>
                  <div className="flex justify-end pt-4">
                    <button
                      onClick={() => {
                        setShowSuccessModal(true);
                      }}
                      className="bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 transition-colors"
                      aria-label="Save notification settings"
                    >
                      <i className="ri-save-line mr-2"></i>
                      Save Notification Settings
                    </button>
                  </div>
                </div>
              </div>
            )} */}

            {activeTab === "portal" && (
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    Customer Portal Settings
                  </h2>
                  <p className="text-gray-600 mt-2">
                    Manage your customer-facing portal and preferences
                  </p>
                </div>

                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-8">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-global-line text-2xl text-white"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Customer Portal Access
                    </h3>
                    <p className="text-gray-600 mb-6 max-w-md mx-auto">
                      Your customers can access their loyalty account through
                      the dedicated customer portal
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                      <button
                        onClick={() => window.open(portalUrl, "_blank")}
                        className="bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 transition-colors flex items-center gap-2 whitespace-nowrap"
                        aria-label="Open customer portal"
                      >
                        <i className="ri-external-link-line"></i>
                        Open Customer Portal
                      </button>

                      <button
                        onClick={() => navigator.clipboard.writeText(portalUrl)}
                        className="bg-white text-blue-600 border border-blue-200 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors flex items-center gap-2 whitespace-nowrap"
                        aria-label="Copy portal URL"
                      >
                        <i className="ri-file-copy-line"></i>
                        Copy Portal URL
                      </button>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Portal Configuration
                  </h3>
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Portal URL
                      </label>
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={portalUrl}
                          disabled
                          className="flex-1 px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                          aria-label="Portal URL"
                        />
                        <button
                          onClick={() =>
                            navigator.clipboard.writeText(
                              `https://simiradiagnostics.primexloyalty.com/`
                            )
                          }
                          className="px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50"
                          aria-label="Copy Portal URL"
                        >
                          <i className="ri-file-copy-line"></i>
                        </button>
                      </div>
                      <p className="text-sm text-gray-500 mt-1">
                        This is your custom customer portal URL
                      </p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Portal Title
                      </label>
                      <input
                        type="text"
                        value={merchantData.portalTitle}
                        onChange={(e) =>
                          handleInputChange("portalTitle", e.target.value)
                        }
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        aria-label="Portal Title"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Welcome Message
                      </label>
                      <textarea
                        rows={3}
                        value={merchantData.welcomeMessage}
                        onChange={(e) =>
                          handleInputChange("welcomeMessage", e.target.value)
                        }
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        aria-label="Welcome Message"
                      />
                    </div>
                  </div>
                </div>
                {/* 
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Portal Features</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {[
                      { id: 'points', label: 'Points Balance', desc: 'Show customer points balance and history' },
                      { id: 'rewards', label: 'Rewards Catalog', desc: 'Display available rewards for redemption' },
                      { id: 'transactions', label: 'Transaction History', desc: 'Show purchase and points transaction history' },
                      { id: 'profile', label: 'Profile Management', desc: 'Allow customers to update their profile' },
                      { id: 'notifications', label: 'Notifications', desc: 'Send promotional and transactional emails' },
                      { id: 'referrals', label: 'Referral Program', desc: 'Enable customer referral system' },
                    ].map((feature) => (
                      <div key={feature.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                        <div>
                          <h4 className="font-semibold text-gray-900">{feature.label}</h4>
                          <p className="text-sm text-gray-600">{feature.desc}</p>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={portalFeatures[feature.id]}
                            onChange={() => handlePortalFeatureToggle(feature.id)}
                            className="sr-only peer"
                          />
                          <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div> */}

                {/* <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">Portal Analytics</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white rounded-lg p-4 border border-gray-200">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                          <i className="ri-user-line text-blue-600"></i>
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-gray-900">1,248</p>
                          <p className="text-sm text-gray-600">Portal Visitors</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-gray-200">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                          <i className="ri-login-box-line text-green-600"></i>
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-gray-900">892</p>
                          <p className="text-sm text-gray-600">Active Users</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-gray-200">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                          <i className="ri-gift-line text-purple-600"></i>
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-gray-900">156</p>
                          <p className="text-sm text-gray-600">Redemptions</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <div className="flex justify-end">
                  <button
                    onClick={() => {
                      setShowSuccessModal(true);
                    }}
                    className="bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 transition-colors"
                    aria-label="Save portal settings"
                  >
                    <i className="ri-save-line mr-2"></i>
                    Save Portal Settings
                  </button>
                </div> */}
              </div>
            )}

            {activeTab === "help" && (
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    Help & Support
                  </h2>
                  <p className="text-gray-600 mt-2">
                    Get help and find answers to common questions
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Quick Help Topics
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {supportTopics.map((topic, index) => (
                      <div
                        key={index}
                        className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow cursor-pointer"
                      >
                        <div
                          className={`w-12 h-12 rounded-xl ${topic.color} flex items-center justify-center mb-4`}
                        >
                          <i className={`${topic.icon} text-xl`}></i>
                        </div>
                        <h4 className="font-semibold text-gray-900 mb-2">
                          {topic.title}
                        </h4>
                        <p className="text-sm text-gray-600">
                          {topic.description}
                        </p>
                        <Link
                          to="/contact-us"
                          className="flex items-center gap-2 mt-3 text-blue-600 text-sm font-medium"
                        >
                          <span>Learn more</span>
                          <i className="ri-arrow-right-line"></i>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    Frequently Asked Questions
                  </h3>
                  <div className="space-y-4">
                    {faqs.map((faq, index) => (
                      <div
                        key={index}
                        className="bg-white border border-gray-200 rounded-xl p-6"
                      >
                        <h4 className="font-semibold text-gray-900 mb-3">
                          {faq.question}
                        </h4>
                        <p className="text-gray-600">{faq.answer}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-8">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-customer-service-line text-2xl text-white"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Need More Help?
                    </h3>
                    <p className="text-gray-600 mb-6 max-w-md mx-auto">
                      Can't find what you're looking for? Our support team is
                      here to help you 24/7.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                      <button
                        onClick={() =>
                          (window.location.href =
                            "mailto:support@primex-loyalty.com")
                        }
                        className="bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-600 transition-colors flex items-center gap-2"
                        aria-label="Email support"
                      >
                        <i className="ri-mail-line"></i>
                        Email Support
                      </button>
                      <button
                        onClick={() =>
                          (window.location.href = "tel:+9123456789")
                        }
                        className="bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors flex items-center gap-2"
                        aria-label="Call support"
                      >
                        <i className="ri-phone-line"></i>
                        Call Support
                      </button>
                      <button
                        onClick={() =>
                          window.open(
                            "https://support.primex-loyalty.com/chat",
                            "_blank"
                          )
                        }
                        className="bg-purple-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-600 transition-colors flex items-center gap-2"
                        aria-label="Live chat"
                      >
                        <i className="ri-message-line"></i>
                        Live Chat
                      </button>
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-6">
                    System Information
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">
                        Platform Version
                      </p>
                      <p className="font-semibold text-gray-900">v2.4.1</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Last Updated</p>
                      <p className="font-semibold text-gray-900">
                        {new Date("2024-03-15").toLocaleDateString("en-IN", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">API Version</p>
                      <p className="font-semibold text-gray-900">v1.8.3</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Support Plan</p>
                      <p className="font-semibold text-green-600">
                        Premium Support
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {showChangePasswordModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-900">
                  Change Password
                </h2>
                <button
                  onClick={() => setShowChangePasswordModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                  aria-label="Close modal"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <form onSubmit={handleChangePassword} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    value={passwordForm.email}
                    disabled
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-600"
                    aria-label="Email"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    New Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    value={passwordForm.newPassword}
                    onChange={(e) =>
                      setPasswordForm({
                        ...passwordForm,
                        newPassword: e.target.value,
                      })
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    required
                    maxLength="16"
                    aria-label="New Password"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Confirm New Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="password"
                    value={passwordForm.confirmPassword}
                    onChange={(e) =>
                      setPasswordForm({
                        ...passwordForm,
                        confirmPassword: e.target.value,
                      })
                    }
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    required
                    maxLength="16"
                    aria-label="Confirm New Password"
                  />
                </div>
                <div className="flex gap-3 pt-4">
                  <button
                    type="button"
                    onClick={() => setShowChangePasswordModal(false)}
                    className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
                    aria-label="Cancel password change"
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="flex-1 px-6 py-3 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors flex items-center justify-center"
                    aria-label="Save new password"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div className="flex items-center gap-2">
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Saving...
                      </div>
                    ) : (
                      <>
                        <i className="ri-save-line mr-2"></i>
                        Save Password
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {showSuccessModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4">
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-green-600"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Settings Saved Successfully
                </h2>
                <p className="text-gray-600 mb-6">
                  Your Settings has been updated successfully. All changes are
                  now active.
                </p>
                <button
                  onClick={() => setShowSuccessModal(false)}
                  className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors"
                  aria-label="Close success modal"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
